"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _pdfButton = _interopRequireDefault(require("../../../../core/pdf-button"));
var _modal = _interopRequireDefault(require("../../../../core/modal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function getInitialState() {
  return {
    selectingPDF: false,
    generatingPDF: false
  };
}
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "This will generate a pdf to be used in control for managing your RTCs. Where the same bib is on the list for both Saturday and Sunday, the entries will be merged to a single RTC");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "You may find it useful to use this alongside the Sign-In sheet (available on the Summary tab).");
class CreateRTCpdf extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", getInitialState());
    _defineProperty(this, "_onCloseCancel", () => {
      this.setState(getInitialState());
    });
    _defineProperty(this, "_onBegin", () => {
      this.setState({
        selectingPDF: true
      });
    });
    // this automatically closes the modal, but delays to allow some time for downloading
    // ideally want to know when generating is finished, but this is a compromise.
    _defineProperty(this, "_onGeneratePDF", () => {
      this.setState({
        generatingPDF: true
      });
      setTimeout(() => {
        this._onCloseCancel();
      }, 2500);
    });
  }
  render() {
    const modalButtons = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_pdfButton.default, {
      name: "rtc-list",
      args: {
        competitionSlug: this.props.competitionSlug,
        yearID: this.props.yearID
      },
      type: "primary",
      disabled: this.state.generatingPDF,
      onClick: this._onGeneratePDF
    }, "Download RTC PDF"), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onCloseCancel
    }, "Cancel"));
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onBegin,
      type: "primary"
    }, "Create RTC PDF"), !this.state.selectingPDF ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: "Create PDF of RTC entries",
      buttons: modalButtons,
      onClose: this._onCloseCancel
    }, _ref, _ref2));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = CreateRTCpdf;